import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  NgZone,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { ResizedEvent } from 'angular-resize-event-package';
import { Sensor } from '../../../models/sensor.model';
import type * as am5xy from '@amcharts/amcharts5/xy';
import { UserPreferences } from '../../../models/userPreferences.model';
import { VideoResource } from '../../../models/videoResource.model';
import type { VgApiService } from '@videogular/ngx-videogular/core';
import type * as am5 from '@amcharts/amcharts5';
import { Subject, Subscription } from 'rxjs';
import { Comment } from '../../../models/comment.model';
import { SensorRecordService } from '../../../services/sensorRecord.service';
import { ChartService } from '../../../services/chart.service';
import { AuthService } from '../../../services';
import { SensorAssignmentService } from 'src/app/services/sensorAssignment.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NodeRecord, SensorRecord } from '../../../models/sensorRecord.model';
import { NodeRecordChartModel } from '../../../models/sensorRecordChart.model';
import { IMapComponent } from '../../chartBase/mapComponent.interface';
import { ActivatedRoute } from '@angular/router';
import { SensorAssignment } from '../../../models/sensorAssignment.model';
import { TaskAssignmentExposureContribution } from '../../../models/taskAssignment.model';
import { NoteService } from '../../../services/note.service';
import { Parameter, ParameterLookup } from '../../../models/parameter.model';
import { OrganizationLevel } from '../../../models/organizationLevel.model';
import { Note } from '../../../models/note.model';
import { RouterStateSnapshot } from '@angular/router';
import { Input } from '@angular/core';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { OnZoom } from '../../chartBase/onZoom.interface';
import { CommonService } from 'src/app/services/common.service';
import { TaskAssignmentService } from 'src/app/services/taskAssignment.service';
import {ComponentNames} from '../../../shared/constants/componentNames.constants';
import { NodeSensorRecordsRequestModel } from 'src/app/models/nodeRecords.model';
import { DateFilterTypeEnum } from 'src/app/enums/dateFilterType.enum';
import { ParameterConstants } from 'src/app/shared/constants/parameter.constants';
import { ValueConversionService } from 'src/app/services/value-conversion.service';

@Component({
  standalone: false,
    selector: 'app-report-chart',
    templateUrl: './report-chart.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./report-chart.component.scss'],
})
export class ReportChartComponent implements OnInit, AfterViewInit,
    AfterViewChecked, OnDestroy, OnZoom, IMapComponent {

    @Output() graphLoaded = new EventEmitter<boolean>();
    @Input() selectedParameter: ParameterLookup;
    @ViewChild('chartContainer', { static: true }) chartContainer: ElementRef;
    isMobile: boolean;
    sensors: Sensor[];
    chartSlider: am5.DataItem<am5xy.IDateAxisDataItem>;
    @ViewChild('modal') modal: ElementRef;
    @ViewChild('modalClick') modalClick: ElementRef;
    @ViewChild('modalDetails') modalDetails: ElementRef;
    @ViewChild('modalDetailsClick') modalDetailsClick: ElementRef;
    readonly CHART_DIV_ID = 'end-point-chart';
    readonly CHART_VIDEO_DIV_ID = 'report-video-chart';
    preferences: UserPreferences;
    activateEndpoint: string;
    zIndex = 0;
    endpointInfoOpen = false;
    endpointAllDetails = false;
    chart: am5xy.XYChart;
    chartDetails: am5xy.XYChart;
    fromDate: Date;
    toDate: Date;
    selectedParams: number[];
    itemsPerPage = 10;
    selectedTab = 1;
    isVideoChartHidden = false;
    videoChart: am5xy.XYChart;
    videoChartSlider: am5.DataItem<am5xy.IDateAxisDataItem>;
    videoResources: VideoResource[];
    vgApi: VgApiService;
    videoDisposers: am5.IDisposer[] = [];
    videoResource: VideoResource;
    shouldCreateSliderButtonEvents = false;
    subscriptions: Subscription[] = [];
    skipRangeTimeUpdate = false;
    skipTrackingAction = false;
    resumeVideoPlay = false;
    allSensorRecords: NodeRecord[] = [];
    comments: Comment[] = [];
    state: RouterStateSnapshot;
    isDateFilter = false;
    timeZone: string;
    isFormLoading = false;
    isLoading = false;
    showSidebarView = false;
    isVideoShow = false;
    screenWidth: string;
    screenHeight: string;
    minHeight: string;
    disposer: am5.IDisposer;
    initDisposer: am5.IDisposer;
    analyticsDisposer: am5.IDisposer;
    analyticsVerticalDisposer: am5.IDisposer;
    sensorAssignmentData: SensorAssignment;
    taskAssignmentExposureData: TaskAssignmentExposureContribution[];
    taskAssignmentDataSource: TaskAssignmentExposureContribution[];
    taskAssignmentColumnsToDisplay = ['taskName', 'taskGroupName', 'locations'];
    taskAssignmentColumnsToDisplayStr = ['Task', 'Task Group', 'Location', 'Time on Shift %', 'Mass Contribution %', 'PPE'];
    taskAssignmentColumnsToDisplayWithExpand = [...this.taskAssignmentColumnsToDisplay, 'timeOnTaskPercentage', 'massContributionPercentage', 'ppeAssignments'];
    taskAssignmentExpandedElement: TaskAssignmentExposureContribution | null;

    refreshUI: Subject<any>;
    clearNotes: Subscription;
    tasksAssignmentNotes: Note[];
    parameters: Parameter[];

    sensorLabResult: any;
    selectedOrg: OrganizationLevel;
    sensorAssignmentId: string;
    showChartFilter = false;
    tasksAssignmentRanges = {};
    tasksAssignmentNotesRanges = {};
    taskRangeVisibility = true;
    colorSet: am5.ColorSet | null = null;
    private colorSetRoot: am5.Root | null = null;
    private am5Ns: typeof import('@amcharts/amcharts5') | null = null;
    showPPE = {};
    componentName = ComponentNames.sampleDetails;
    taskColor = {};
    taskSelectColor = {};
    destroy$ = new Subject<void>();

    selectedTaskName = '';
    loadCommentsAndNotes = true;
    loadingAssessments = true;
    selectedDateRange: any;
    private playVideoTimeoutId: ReturnType<typeof setTimeout> | undefined;
    private skipTrackingTimeoutId: ReturnType<typeof setTimeout> | undefined;
    private setVideoTimeTimeoutId: ReturnType<typeof setTimeout> | undefined;
    private endpointInfoTimeoutId: ReturnType<typeof setTimeout> | undefined;
    private endpointAllDetailTimeoutId: ReturnType<typeof setTimeout> | undefined;
    private taskRangeTimeoutId: ReturnType<typeof setTimeout> | undefined;
    private showPPETimeoutId: ReturnType<typeof setTimeout> | undefined;

    constructor(
        private route: ActivatedRoute,
        private sensorRecordService: SensorRecordService,
        private chartService: ChartService,
        private authService: AuthService,
        private zone: NgZone,
        private renderer: Renderer2,
        private noteService: NoteService,
        private sensorAssignmentService: SensorAssignmentService,
        private deviceService: DeviceDetectorService,
        private cd: ChangeDetectorRef,
        private commonService: CommonService,
        private taskAssignmentService: TaskAssignmentService,
        private valueConversionService: ValueConversionService
    ) {
        const currentUser = this.authService.getCurrentUser();
        this.preferences = currentUser.preferences;
        this.renderer.listen('window', 'click', (e: Event) => {
            const modalId = document.getElementById('post_comment');
            if (!modalId && (!this.modalClick || !this.modal.nativeElement.contains(e.target)) &&
                (!this.modalClick || !this.modalClick.nativeElement
                    || !this.modalClick.nativeElement.contains(e.target)) && !this.isDateFilter) {
            }
        });
        this.renderer.listen('window', 'click', (e: Event) => {
            if (this.modalDetails && this.modalDetailsClick && !this.isDateFilter) {
                if (!this.modalDetails.nativeElement.contains(e.target) && !this.modalDetailsClick.nativeElement.contains(e.target)) {
                    this.endpointAllDetails = false;
                }
            }
        });
        this.minHeight = (window.innerHeight - 100) + 'px';
        this.timeZone = currentUser.userTimeZone;

        this.isMobile = this.deviceService.isMobile();
        this.refreshUI = new Subject();
        this.refreshUI.subscribe(() => {
            this.endPointInfo();
            this.loadTaskAssignments();
        });
    }

    ngAfterViewChecked(): void {
        this.cd.detectChanges();
    }

    ngAfterViewInit(): void {
        this.cd.detectChanges();
    }

    ngOnInit(): void {
        this.chartService.getAmCharts5().then(({ am5: am5Ns }) => {
            this.am5Ns = am5Ns;
            this.colorSetRoot = am5Ns.Root.new(document.createElement('div'));
            this.colorSetRoot.setThemes([]);
            this.colorSet = am5Ns.ColorSet.new(this.colorSetRoot, { step: 2 });
        });
        this.loadHeaderData();
        this.sensorAssignmentId = this.route.snapshot.params.id;

        this.loadSampleDetails(this.sensorAssignmentId);
        this.activateEndpoint = '';
        this.selectedParams = this.chartService.getDefaultParameters();
        if (window.innerWidth < 700) {
            this.screenWidth = (window.innerWidth - (window.innerWidth * 0.4)) + 'px !important';
            this.screenHeight = window.innerHeight + 'px !important';
        } else {
            this.showSidebarView = true;
        }
    }

    private loadTaskAssignments() {
        if (this.sensorAssignmentData?.id && this.selectedParameter?.id) {
            this.loadingAssessments = true;
            this.taskAssignmentService.getExposureContributions(this.sensorAssignmentData.id, this.selectedParameter.id).subscribe((tasksAssignmentData) => {
                tasksAssignmentData.forEach((taskAssignment, index) => {
                    taskAssignment.taskAssignments.forEach((assignment) => {
                        this.getNotes(assignment.id);
                    });
                });
                const result = [];
                const seenTaskIds = new Set<string>();
                tasksAssignmentData.forEach((task, index) => {
                    const baseColor = this.colorSet?.getIndex(index);
                    this.taskColor[task.taskName] = baseColor && this.am5Ns ? this.am5Ns.Color.lighten(baseColor, 0.4) : undefined;
                    this.taskSelectColor[task.taskName] = baseColor && this.am5Ns ? this.am5Ns.Color.lighten(baseColor, 0.7) : undefined;
                    if (!seenTaskIds.has(task.taskId)) {
                        seenTaskIds.add(task.taskId);
                        result.push(task);
                        task.visible = true;
                    }
                });

                this.taskAssignmentExposureData = tasksAssignmentData;
                this.taskAssignmentDataSource = this.commonService.computeMassContribution(result);
                this.loadingAssessments = false;
            }, error => {
                this.loadingAssessments = false;
                this.taskAssignmentExposureData = [];
                this.taskAssignmentDataSource = [];
            });
        }
    }

    endPointInfo() {
        clearTimeout(this.endpointInfoTimeoutId);
        this.endpointInfoTimeoutId = setTimeout(() => {
            this.endpointInfoOpen = true;
            this.zone.runOutsideAngular(() => {
                setTimeout(async () => {
                    this.chart = await this.chartService.createChart(this.CHART_DIV_ID);
                }, 50);
            });
            this.createLineChart();
        }, 100);
    }

    endpointAllDetail(sensorRecords: NodeRecord[] = [], parameterName = null, parameterFieldName = null) {
        this.endpointAllDetails = true;
        clearTimeout(this.endpointAllDetailTimeoutId);
        this.endpointAllDetailTimeoutId = setTimeout(() => {
            this.zone.runOutsideAngular(async () => {
                this.chartDetails = await this.chartService.createChart('end-point-chart-details');
                this.chartSlider = await this.chartService.createChartRange(this.chartDetails);
                await this.chartService.drawSensorRecordChart(this.chartDetails, sensorRecords, [this.selectedParameter.parameterType],
                    this, this.comments, null, this.refreshUI, this.taskAssignmentExposureData, this.componentName, false, parameterName, parameterFieldName);
                this.videoChart = await this.chartService.createChart(this.CHART_VIDEO_DIV_ID);
                this.videoChartSlider = await this.chartService.createChartSlider(this.videoChart, this);
                this.isVideoChartHidden = !this.videoResources || this.videoResources.length === 0;
                await this.chartService.drawVideoChart(this.videoChart, this.videoResources);
                this.createChartZoomEvent();
                this.graphLoaded.emit(true);
                this.chartService.disposeEvent(this.initDisposer);
                this.initDisposer = this.zone.runOutsideAngular(() => {
                    return this.chartService.createChartInitialZoomEvent(this.chartDetails, this, false);
                });
                clearTimeout(this.taskRangeTimeoutId);
                this.taskRangeTimeoutId = setTimeout(() => {
                this.showTaskRange(true, null);
                }, 2000);

                if (this.videoResources && this.videoResources.length > 0) {
                    this.videoResource = this.videoResources[0];
                    if (this.vgApi) {
                        // tslint:disable-next-line:max-line-length
                        this.videoDisposers = this.chartService.createChartSliderButtonEvents(this.videoChartSlider, this.videoResource.timestampStart, this.videoChart, this.videoDisposers, this);
                        this.vgApi.currentTime = 0;
                    } else {
                        this.shouldCreateSliderButtonEvents = true;
                    }
                } else {
                    this.videoResource = null;
                }
            });
        }, 400);
    }

    ngOnDestroy() {
        clearTimeout(this.playVideoTimeoutId);
        clearTimeout(this.skipTrackingTimeoutId);
        clearTimeout(this.setVideoTimeTimeoutId);
        clearTimeout(this.endpointInfoTimeoutId);
        clearTimeout(this.endpointAllDetailTimeoutId);
        clearTimeout(this.taskRangeTimeoutId);
        clearTimeout(this.showPPETimeoutId);
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
        this.destroy$.next();
        this.destroy$.complete();
        if (this.clearNotes) this.clearNotes.unsubscribe();

        this.zone.runOutsideAngular(() => {
            this.chartService.disposeEvent(this.disposer);
            this.chartService.disposeEvent(this.initDisposer);
            this.chartService.disposeEvent(this.analyticsDisposer);
            this.chartService.disposeEvent(this.analyticsVerticalDisposer);
            if (this.chart) {
                this.chartService.disposeChartData(this.chart);
                this.chart.dispose();
            }
            if (this.videoChart) {
                this.chartService.disposeChartData(this.videoChart);
                this.videoChart.dispose();
                this.videoChartSlider = null;
                this.chartSlider = null;
            }
            if (this.colorSetRoot) {
                this.colorSetRoot.dispose();
                this.colorSetRoot = null;
            }
        });

    }

    clearCommentRanges(event) {
        if (this.tasksAssignmentNotes) {
            this.tasksAssignmentNotes.forEach((resource, index) => {
                if (this.tasksAssignmentNotesRanges[resource.id]) this.tasksAssignmentNotesRanges[resource.id].axisFill.visible = false;
            });
        }
        this.chartService.clearCommentRanges();
    }

    clearTaskRanges(event) {
        if (this.taskAssignmentExposureData) {
            this.taskAssignmentExposureData.forEach((resource, index) => {
                if (this.tasksAssignmentRanges[resource.taskId]) {
                    this.tasksAssignmentRanges[resource.taskId].forEach((assignment: am5.DataItem<am5xy.IDateAxisDataItem>) => {
                        assignment.get('axisFill')?.set('visible', false);
                    });
                }
            });
            this.taskRangeVisibility = true;
            this.selectedTaskName = "";
        }
    }

    createLineChart() {
       const payload: NodeSensorRecordsRequestModel = {
            orgLevelId: this.selectedOrg?.id,
            analyteId: this.selectedParameter?.id,
            endPointId: this.sensorAssignmentData?.endPointId,
            dateFilterType:
              this.selectedDateRange?.id || this.selectedDateRange?.id == 0
                ? this.selectedDateRange?.id
                : DateFilterTypeEnum.AllDates,
            startDate: this.selectedDateRange?.start
              ? this.selectedDateRange?.start
              : 0,
            endDate: this.selectedDateRange?.end ? this.selectedDateRange?.end : 0,
            includeVideo: false,
            sensorAssignmentId : this.sensorAssignmentData?.id
          };
        const parameters = this.preferences.parameters;
        if (parameters.length > 0) {
            this.loadCommentsAndNotes = true;
            this.sensorRecordService.getNodeRecords(payload).subscribe((result: NodeRecordChartModel) => {
                const sensorRecords = result.nodeRecords;
                this.comments = [];
                const videoResources = result.videoResources ? result.videoResources.reverse() : [];
                const noiseDate = new Date();
                noiseDate.setMinutes(noiseDate.getDate() - 500);
                let totalSum = 0;
                let parameterName: string = null;
                if (sensorRecords) {
                  sensorRecords.forEach((record) => {
                    record.endPointId = this.sensorAssignmentData?.endPointId;
                    record.timestamp *= 1000;
                    totalSum +=
                      this.valueConversionService.getParameterValueFromUserPreferences(
                        record.value,
                        this.selectedParameter.parameterType
                      );
                    record.cumulativeSum = totalSum;

                    if (record?.value != null) {
                      parameterName = this.selectedParameter.name;
                      record[ParameterConstants.parameterFieldName] =
                        this.valueConversionService.getParameterValueFromUserPreferences(
                          record.value,
                          this.selectedParameter.parameterType
                        );
                    }
                  });
                  sensorRecords.forEach((record) => {
                    record.cumulativeSumPercentage =
                      (record.cumulativeSum / totalSum) * 100;
                  });
                }
                videoResources.forEach(
                    resource => {
                        resource.timestampStart *= 1000;
                        resource.timestampEnd *= 1000;
                    });
                this.videoResources = videoResources;
                this.allSensorRecords = sensorRecords;
                if (this.comments && Array.isArray(this.comments)) {
                    this.comments.sort((x, y) => -(x.fromDate - y.toDate));
                }
                this.zone.runOutsideAngular(() => {
                    this.endpointAllDetail(sensorRecords, parameterName, ParameterConstants.parameterFieldName);
                    this.loadCommentsAndNotes = false;
                });

            });
            this.loadTaskAssignments();
        }
    }

    onResized(event: ResizedEvent, chart, chartDivId: string) {
        this.chartService.onResized(chart, event, chartDivId);
    }

    onVideoResized(event: ResizedEvent) {
        this.chartService.onResized(this.videoChart, event, this.CHART_VIDEO_DIV_ID);
    }

    updateMap(sensorRecords: SensorRecord[], shouldRecordBulletClick: boolean = false) {

    }

    onPlayerReady(api: VgApiService) {
        this.vgApi = api;

        if (this.shouldCreateSliderButtonEvents) {
            this.zone.runOutsideAngular(() => {
                this.videoDisposers = this.chartService.createChartSliderButtonEvents(
                    this.videoChartSlider, this.videoResource.timestampStart,
                    this.videoChart, this.videoDisposers, this);
            });
        }

        this.subscriptions.push(api.subscriptions.timeUpdate.subscribe(event => {
            if (!this.videoResource || !this.videoResource.timestampStart) {
                return;
            }
            let currentTime = this.videoResource.timestampStart + event.srcElement.currentTime * 1000;
            currentTime = Math.max(this.videoResource.timestampStart, currentTime);
            currentTime = Math.min(this.videoResource.timestampEnd, currentTime);

            if (!this.skipRangeTimeUpdate) {
                this.videoChartSlider.set('value', currentTime);
                this.chartSlider.set('value', currentTime);
            }

            const videoDateAxis = this.videoChart.xAxes.getIndex(0) as am5xy.DateAxis<am5xy.AxisRendererX>;
            const videoMin = videoDateAxis.get('min');
            const videoMax = videoDateAxis.get('max');
            if (videoMin && videoMin > currentTime) {
                videoDateAxis.set('min', currentTime - 5000);
            }
            if (videoMax && videoMax < currentTime) {
                videoDateAxis.set('max', currentTime + 5000);
            }
        }));

        this.subscriptions.push(api.getDefaultMedia().subscriptions.ended.subscribe(
            this.nextVideo.bind(this)
        ));

        this.subscriptions.push(api.getDefaultMedia().subscriptions.play.subscribe(
            () => this.onVgApiAction(true)
        ));

        this.subscriptions.push(api.getDefaultMedia().subscriptions.pause.subscribe(
            () => this.onVgApiAction(false)
        ));
    }

    onVgApiAction(shouldResume: boolean) {
        if (this.skipTrackingAction) {
            return;
        }
        this.resumeVideoPlay = shouldResume;
    }

    nextVideo() {
        const index = this.videoResources.indexOf(this.videoResource);
        if (index >= 0 && index < this.videoResources.length - 1) {
            this.videoResource = this.videoResources[index + 1];
            this.isVideoShow = true;
            this.videoDisposers = this.chartService.createChartSliderButtonEvents(this.videoChartSlider,
                this.videoResource.timestampStart, this.videoChart, this.videoDisposers, this);
            clearTimeout(this.playVideoTimeoutId);
            this.playVideoTimeoutId = setTimeout(() => this.playVideo(), 200);
        }
    }

    playVideo() {
        this.skipTrackingAction = true;
        this.vgApi.play();
        this.resumeVideoPlay = true;
        clearTimeout(this.skipTrackingTimeoutId);
        this.skipTrackingTimeoutId = setTimeout(() => this.skipTrackingAction = false, 50);
    }

    jumpToVideoTime(timestamp: number) {
        if (timestamp === 0) {
            this.skipTrackingAction = true;
            this.vgApi.pause();
            this.resumeVideoPlay = false;
            clearTimeout(this.skipTrackingTimeoutId);
            this.skipTrackingTimeoutId = setTimeout(() => this.skipTrackingAction = false, 50);
            return;
        }
        this.skipTrackingAction = false;

        let resourceUpdated = false;
        if (!this.videoResource.url || timestamp < this.videoResource.timestampStart || timestamp > this.videoResource.timestampEnd) {
            const resource = this.videoResources.find(r => r.timestampStart <= timestamp && r.timestampEnd >= timestamp);

            if (!resource) {
                this.videoResource = new VideoResource();
                this.isVideoShow = false;
                this.chartSlider.set('value', timestamp);
                return;
            }

            this.skipRangeTimeUpdate = true;
            this.videoResource = resource;
            this.isVideoShow = true;
            this.videoDisposers = this.chartService.createChartSliderButtonEvents(this.videoChartSlider, this.videoResource.timestampStart
                , this.videoChart, this.videoDisposers, this, false);
            this.videoChartSlider.set('value', timestamp);
            this.chartSlider.set('value', timestamp);
            resourceUpdated = true;
        }

        if (resourceUpdated) {
            clearTimeout(this.setVideoTimeTimeoutId);
            this.setVideoTimeTimeoutId = setTimeout(() => this.setVideoTime(timestamp), 200);
        } else {
            this.setVideoTime(timestamp);
        }
    }

    setVideoTime(timestamp: number) {
        const totalTime = this.videoResource.timestampEnd - this.videoResource.timestampStart;
        let timeElapsed = timestamp - this.videoResource.timestampStart;
        timeElapsed = Math.max(0, timeElapsed);
        timeElapsed = Math.min(totalTime, timeElapsed);
        this.vgApi.currentTime = Math.min(this.vgApi.time.total, timeElapsed / 1000);
        this.skipRangeTimeUpdate = false;

        if (this.resumeVideoPlay) {
            this.playVideo();
        }
    }

    hideView() {
        this.endpointInfoOpen = false;
        this.endpointAllDetails = false;
    }

    private getNotes(id: string | undefined) {
        this.tasksAssignmentNotes = [];
        this.noteService.getNotes(id).subscribe((notesData) => {
            for (let i = 0; i < notesData.length; i++) {
                this.tasksAssignmentNotes.push(notesData[i]);
            }
        });
    }

    private loadSampleDetails(id: string | undefined) {
        this.sensorAssignmentService.getById(id).subscribe((data) => {
            this.sensorAssignmentData = data;
            try {
                this.sensorLabResult = this.sensorAssignmentData?.labResult ? JSON.parse(this.sensorAssignmentData?.labResult) : null;
            } catch (e) {
            }

            this.endPointInfo();
        });
    }

    showTaskRange(visibility = false, taskName = null) {
        clearTimeout(this.taskRangeTimeoutId);
        this.taskRangeTimeoutId = setTimeout(async () => {
            this.showChartFilter = false;
            if (taskName) {
                if (this.selectedTaskName != taskName) visibility = true;
                this.selectedTaskName = taskName;
            }
            const dateAxis = this.chartDetails.xAxes.getIndex(0) as am5xy.DateAxis<am5xy.AxisRendererX>;
            if (this.taskAssignmentExposureData) {
                this.taskAssignmentExposureData.forEach((resource, index) => {
                    if (!this.tasksAssignmentRanges[resource.taskId]) {
                        this.tasksAssignmentRanges[resource.taskId] = [];
                        resource.taskAssignments.forEach((assignment) => {
                            const rangeItem = dateAxis.makeDataItem({
                                value: assignment.startDate * 1000,
                                endValue: assignment.endDate * 1000,
                            });
                            dateAxis.createAxisRange(rangeItem);
                            rangeItem.get('axisFill')?.set('fillOpacity', 0.3);
                            rangeItem.get('label')?.set('text', '');
                            this.tasksAssignmentRanges[resource.taskId].push(rangeItem);
                        });
                    }
                    this.tasksAssignmentRanges[resource.taskId].forEach((assignment: am5.DataItem<am5xy.IDateAxisDataItem>) => {
                        assignment.get('label')?.set('fill', this.taskColor[resource.taskName]);
                        assignment.get('axisFill')?.set('fill', this.taskColor[resource.taskName]);
                        const isVisible = ((resource.taskName === taskName) || (taskName === null)) ? visibility : false;
                        assignment.set('visible', isVisible);
                        assignment.get('axisFill')?.set('visible', isVisible);
                        assignment.get('label')?.set('visible', isVisible);
                    });
                });
            }
            this.taskRangeVisibility = true;
            this.chartService.showHideComments(false);
            if (this.tasksAssignmentNotes) {
                this.tasksAssignmentNotes.forEach((resource, index) => {
                    if (this.tasksAssignmentNotesRanges[resource.taskId]) {
                        this.tasksAssignmentRanges[resource.taskId].forEach((assignment: am5.DataItem<am5xy.IDateAxisDataItem>) => {
                            assignment.get('axisFill')?.set('visible', false);
                            assignment.get('label')?.set('visible', false);
                            assignment.get('bullet')?.get('sprite')?.set('visible', false);
                        });
                    }
                });
            }
        }, 200);
        this.graphLoaded.emit(true);
    }

    showHidePPE(i, show = false) {
        for (const showPPEKey in this.showPPE) {
            this.showPPE[showPPEKey] = false;
        }
        if (!show) {
            clearTimeout(this.showPPETimeoutId);
            this.showPPETimeoutId = setTimeout(() => {
                this.showPPE[i] = show;
            }, 2000);
        } else {
            this.showPPE[i] = show;
        }
    }

    onInitialZoom(sensorRecords: SensorRecord[]) {
        if (this.initDisposer && !this.initDisposer.isDisposed() && sensorRecords && sensorRecords.length > 0) {
            this.onDataZoom(sensorRecords);
        }
    }

    onZoom(sensorRecords: SensorRecord[]) {
        if (sensorRecords && sensorRecords.length > 0 && this.initDisposer && !this.initDisposer.isDisposed()) {
            this.initDisposer.dispose();
        }
        this.onDataZoom(sensorRecords);
    }

    onAnalyticsHorizontalZoom() {
    }

    onAnalyticsVerticalZoom() {
    }

    onDataZoom(sensorRecords: SensorRecord[]) {
        this.updateMap(sensorRecords);

        const dateAxis = this.chartDetails.xAxes.getIndex(0) as am5xy.DateAxis<am5xy.AxisRendererX>;
        const minZoomed = dateAxis.getPrivate('selectionMin') as number | undefined;
        const maxZoomed = dateAxis.getPrivate('selectionMax') as number | undefined;
        if (this.videoResources && this.videoChart && this.videoResources.length > 0 && minZoomed && maxZoomed) {
            const videoDateAxis = this.videoChart.xAxes.getIndex(0) as am5xy.DateAxis<am5xy.AxisRendererX>;
            videoDateAxis.set('min', minZoomed);
            videoDateAxis.set('max', maxZoomed);
        }
    }

    createChartZoomEvent() {
        this.chartService.disposeEvent(this.disposer);
        this.disposer = this.zone.runOutsideAngular(() => {
            return this.chartService.createChartZoomEvent(this.chartDetails, this);
        });
        this.chartService.disposeEvent(this.analyticsDisposer);
        this.analyticsDisposer = this.zone.runOutsideAngular(() => {
            return this.chartService.createChartAnalyticsEvent(this.chartDetails, this);
        });
        this.chartService.disposeEvent(this.analyticsVerticalDisposer);
        this.analyticsVerticalDisposer = this.zone.runOutsideAngular(() => {
            return this.chartService.createChartAnalyticsVerticalZoomEvent(this.chartDetails, this);
        });
    }

    loadHeaderData() {
        this.selectedParameter = JSON.parse(localStorage.getItem('selectedParameter'));
        this.selectedOrg = JSON.parse(localStorage.getItem('selectedOrg'));
        this.selectedDateRange = JSON.parse(localStorage.getItem('dateRange'));
    }

    public trackByIndex = trackByIndex;
}



